import { Box, Flex } from '@chakra-ui/react';
import { ListPageTitle } from 'components/atoms/ListPageTitle';

export const MenuCategoryHeaderView = () => (
  <Box m="40px 5px 0 5px">
    <Flex justifyContent="space-between" alignItems="center" h="40px">
      <ListPageTitle title="メニュー管理" />
    </Flex>
  </Box>
);
